import {
	AppStorage,
	CustomProvidersStore,
	IndexedDBStorageBackend,
	ProviderKeysStore,
	SessionsStore,
	SettingsStore,
	setAppStorage,
} from "@earendil-works/pi-web-ui";

/**
 * Initialise pi-web-ui's global IndexedDB-backed AppStorage.
 *
 * pi-web-ui components (ChatPanel, AgentInterface, ModelSelector, …) call
 * `getAppStorage()` lazily and throw if it hasn't been set up. Call this once
 * before any UI tab mounts. Idempotent.
 */
let initialised = false;

export function initAppStorage(): void {
	if (initialised) return;
	initialised = true;

	const settings = new SettingsStore();
	const providerKeys = new ProviderKeysStore();
	const sessions = new SessionsStore();
	const customProviders = new CustomProvidersStore();

	const backend = new IndexedDBStorageBackend({
		dbName: "jtm-pi-ui",
		version: 2,
		stores: [
			settings.getConfig(),
			providerKeys.getConfig(),
			SessionsStore.getMetadataConfig(),
			sessions.getConfig(),
			customProviders.getConfig(),
		],
	});

	settings.setBackend(backend);
	providerKeys.setBackend(backend);
	sessions.setBackend(backend);
	customProviders.setBackend(backend);

	setAppStorage(new AppStorage(settings, providerKeys, sessions, customProviders, backend));
}
